import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import {
 submitSupportRequest,
 getSupportHistory,
} from "../../services/supportService";
import { BRAND_COLOR } from "../../../common/constants";
import "./Support.css";

const Support = () => {
 const storedUser = localStorage.getItem("user");
 const user = storedUser ? JSON.parse(storedUser) : null;

 const [form, setForm] = useState({
 name: user?.name || "",
 email: user?.email || "",
 message: "",
 });

 const [loading, setLoading] = useState(false);
 const [success, setSuccess] = useState(false);
 const [error, setError] = useState("");

 const handleChange = (e) =>
 setForm({ ...form, [e.target.name]: e.target.value });

const handleSubmit = async (e) => {
 e.preventDefault();

 setError("");
 setSuccess(false);

 if (!form.name || !form.email || !form.message) {
 setError("All fields are required");
 return;
 }

 setLoading(true);

 try {
 await submitSupportRequest(form);

 setSuccess(true);
 setForm((p) => ({ ...p, message: "" }));
 } catch (err) {
 setError("Something went wrong. Please try again.");
 } finally {
 setLoading(false);

 }
};


 // Optional: fetch ticket history on mount
 const [tickets, setTickets] = useState([]);
 useEffect(() => {
 const fetchTickets = async () => {
 try {
 const res = await getSupportHistory();
 setTickets(res.data || []);
 } catch (err) {

 }
 };

 fetchTickets();
 }, []);

 return (
 <div className="login-page">
 <Navbar />

 <div className="login-wrapper">
 <div className="form-container">
 <h2>Contact Support</h2>
 <p className="subtitle">
 Need help? Send us a message and we’ll assist you.
 </p>

 <form onSubmit={handleSubmit}>
 <div className="input-group">
 <input
 name="name"
 value={form.name}
 onChange={handleChange}
 placeholder=" "
 disabled={!!user?.id}
 />
 <label>Name</label>
 </div>

 <div className="input-group">
 <input
 name="email"
 value={form.email}
 onChange={handleChange}
 placeholder=" "
 disabled={!!user?.id}
 />
 <label>Email</label>
 </div>

 <div className="input-group">
 <textarea
 name="message"
 rows={4}
 value={form.message}
 onChange={handleChange}
 placeholder=" "
 />
 <label>Message</label>
 </div>

 {error && <p className="support-error">{error}</p>}
 {success && (
 <p className="support-success">
 ✅ Support ticket submitted successfully
 </p>
 )}

 <button className="login-btn" disabled={loading}>
 {loading ? "Sending..." : "Send Message"}
 </button>

 <p className="support-link">
 Already raised a ticket?{" "}
 <Link to="/support/tickets">View My Tickets</Link>
 </p>
 </form>

 
 </div>
 </div>
 </div>
 );
};

export default Support;
